import React, { useState, useRef, useEffect } from 'react';
import './otp.scss';
import { OtpInputProps } from '../../types';

const OtpInput: React.FC<OtpInputProps> = ({ setOtpValue, showValues = false }) => {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const inputRefs = [
    useRef<HTMLInputElement | null>(null),
    useRef<HTMLInputElement | null>(null),
    useRef<HTMLInputElement | null>(null),
    useRef<HTMLInputElement | null>(null),
    useRef<HTMLInputElement | null>(null),
    useRef<HTMLInputElement | null>(null),
  ];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number): void => {
    const value: string = e.target.value;
    if (/[^0-9]/.test(value)) return;
    const newOtp: string[] = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < inputRefs.length - 1 && !newOtp[index + 1]) {
      inputRefs[index + 1].current?.focus();
    }

    const concatenatedOtp: string = newOtp.join('');
    setOtpValue(concatenatedOtp);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number): void => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs[index - 1].current?.focus();
    }
  };

  const handlePaste = (e: any) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData('text').replace(/[^0-9]/g, '');
    if (pasteData) {
      const newOtp = [...otp];
      for (let i = 0; i < pasteData.length && i < inputRefs.length; i++) {
        newOtp[i] = pasteData[i];
        if (inputRefs[i].current) {
          const inputRef: any = inputRefs[i]?.current;
          inputRef.value = pasteData[i];
        }
      }
      setOtp(newOtp);
      setOtpValue(newOtp.join(''));
      const nextEmptyIndex = newOtp.findIndex((val) => val === '');
      if (nextEmptyIndex >= 0) {
        const inputRef: any = inputRefs[nextEmptyIndex].current;
        inputRef.focus();
      }
    }
  };

  useEffect(() => {
    const input: any = inputRefs[0].current;
    input.focus();
  }, []);

  return (
    <div className="otp-container">
      {otp.map((digit, index) => (
        <input
          key={index}
          type={showValues ? 'text' : 'password'}
          maxLength={1}
          value={digit}
          inputMode="numeric"
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={handlePaste}
          className="otp-input"
          ref={inputRefs[index]}
          autoComplete="false"
        />
      ))}
    </div>
  );
};

export default OtpInput;
